import Backbone from 'backbone';

import ParseService from '~/services/parseService';
import Model from '~/models/parseModel';
import Collection from '~/collections/parseCollection';
import toastr from 'toastr';

var fileService;
export default function () {

    var FileModel = Model.extend({
        className: "News",
        defaults: {
			'manualTitle': false,
        },
    });

    var FileCollection = Collection.extend({
        model: FileModel,
    });
    var FileService = ParseService.extend({
        sortBy: 'createdAt',
        order: 'dsc',
        itemsOnPage: 100, // load by N items, this overrides the 1k limit 'parseService.js'
        model: FileModel,
        collection: FileCollection,
		createSimpleFile:function(title, info, newsLink, file, user, xl){
			var News = Parse.Object.extend("News");
			var news = new News();
			news.set("File",file);
			news.set('title',title);
			news.set('body',info);
			news.set('newsLink',newsLink);
			news.set('user',{__type: "Pointer", className: "_User", objectId: user});
			news.save(null, {
				success: function(adminnote) {
					xl();
				},
				error: function(adminnote, error) {
					console.log(error);
					switch(error.code){
						case 100:
							toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
						break;
					}
				}
			});
		},
		
		updateNews:function(newsid, title, info, newsLink, file, changeFile, xl){
			var News = Parse.Object.extend("News");
			var query = new Parse.Query(News);
			query.equalTo("objectId", newsid);
			query.first({
				success: function(news) {
					news.set('title',title);
					news.set('body',info);
					news.set('newsLink',newsLink);
					if(changeFile){
						news.set("File",file);
                    }
                    news.save(null, {
						success: function(updatedNews) {
							xl(updatedNews);
						},
						error: function(updatedNews, error) {
							console.log(error);
							switch(error.code){
								case 100:
									toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
								break;
							}
						}
					});
				},
				error: function(error) {
					console.log(error);
					switch(error.code){
						case 100:
							toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
						break;
					}
				}
            });
        },
		
		deleteNews: function(newsid, xl){
			var News = Parse.Object.extend("News");
			var query = new Parse.Query(News);
			query.equalTo("objectId", newsid);
			query.first({
				success: function(object) {
					object.destroy().then((response) => {
						xl();
					},
					(error) => {
						console.log(error);
						switch(error.code){
							case 100:
								toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
							break;
						}
					});
				},
				error: function(error) {
					console.log(error);
					switch(error.code){
						case 100:
							toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
						break;
					}
				}
			});
		}
	});

	return fileService || (fileService = new FileService());
};
// only created once for application
